import materials from "./helpers/materials";
import sizes from "./helpers/sizes";
import PrintContainer from "../components/editor/PrintContainer";
import PrintLayers from "../components/editor/PrintLayers";
import {ddToDms} from "./helpers";

export const baseEditor = {
    components: {
        PrintContainer,
        PrintLayers,
    },

    computed: {
        addToCartUrl() {
            const params = new URLSearchParams(this.print);
            params.append('type', this.type);

            // todo fix url
            return `/shoppingcart/add/?${params}`;
        },

        currentSize() {
            return this.sizes.find(size => size.name === this.print.size) || this.sizes[0];
        },

        currentMaterial() {
            return this.materials.find(material => material.material === this.print.material);
        },

        console: () => console,
        tileserver: () => tileserver,

        showZoom() {
            return this.type && (this.type !== 'coordinate');
        },

        showMoveHint() {
            return this.type && (this.type !== 'coordinate');
        },

        printStyles() {
            if (this.print.orientation === 'horizontal')
                return {
                    'width': this.posterSize.height + 'px',
                    'height': this.posterSize.width + 'px',
                }

            return {
                'width': this.posterSize.width + 'px',
                'height': this.posterSize.height + 'px',
            }
        },
    },

    data() {
        return {
            initialState: {},
            showMaterialModal: false,
            rotatable: false,

            print: {},
            materials,
            sizes,
        }
    },

    watch: {
        'print.material': {
            handler: function (newMaterial, oldMaterial) {
                console.log('print.material change', newMaterial, oldMaterial)
                console.log('this.print.size', this.print.size)

                const size = sizes.find(it => it.material === this.print.material && it.name === this.print.size) ??
                    sizes.filter(it => it.material === this.print.material)[1]

                this.print.size = size.name
            }
        },

        'posterSize': {
            handler: function (after, before) {
                setTimeout(() => {
                    this.$nextTick(() => {
                        window.bus.$emit('resize');
                    });
                }, 100);
            },
            deep: true,
        },
        'print.lng': {
            handler: function () {
                // console.log('print.lng')
                // console.log('this.print.useCoordinates', this.print.useCoordinates)

                if (this.print.useCoordinates === true || this.print.useCoordinates === 'true') {
                    this.setCoordinates()
                }
            }
        },
        'print.lat': {
            handler: function () {
                // console.log('print.lat')
                // console.log('this.print.useCoordinates', this.print.useCoordinates)

                if (this.print.useCoordinates === true || this.print.useCoordinates === 'true') {
                    this.setCoordinates()
                }
            }
        },
        'print.orientation': {
            handler: function (after, before) {
                setTimeout(() => {
                    this.$nextTick(() => {
                        window.bus.$emit('resize');
                    });
                }, 100);
            },
            deep: true,
        },
        'print.size': {
            handler: function (after, before) {
                // calc new size
                const size = this.currentSize;

                const mapRatio = size.height / size.width;
                const newHeight = this.defaultWidth * mapRatio;

                this.posterSize.width = this.defaultWidth;
                this.posterSize.height = newHeight
            },
            deep: true,
        },

        'print': {
            handler: function (val, oldVal) {
                // console.log(val);

                this.syncUrl();
            },
            deep: true
        },
    },

    beforeMount() {
        // console.log('beforeMount!');

        // Restore poster from url
        // const urlParams = new URLSearchParams(location.search);
        // const entries = urlParams.entries(); // Returns an iterator of decoded [key,value] tuples
        // const params = this.paramsToObject(entries);

        let params = {};
        // console.log('params', params)

        try {
            const search = location.search.substring(1);
            params = JSON.parse(
                '{"' +
                search.replace(/&/g, '","')
                    .replace(/=/g, '":"') + '"}',
                function (key, value) {
                    return key === "" ? value : decodeURIComponent(value.replace(/\+/g, ' '))
                });
        } catch {
        }

        let query = null;

        delete params.format;

        this.printmode = params.printmode || false;
        delete params.printmode;

        this.previewmode = params.previewmode || false;
        delete params.previewmode;

        if (params.layers) {
            params.layers = params.layers.replace(',labels_modern', '')
        }

        if (params.lat && isNaN(params.lat)) {
            delete params.lat
        }
        if (params.lng && isNaN(params.lng)) {
            delete params.lng
        }
        if (params.zoom && isNaN(params.zoom)) {
            delete params.zoom
        }
        if (params.orientation && !(['vertical', 'horizontal'].includes(params.orientation))) {
            delete params.orientation
        }

        if (params.plaatsnaam) {
            query = params.plaatsnaam;
            delete params.plaatsnaam;
        }
        if (params.query) {
            query = params.query;
            delete params.query;
        }

        this.print = {
            ...this.initialState,
            ...params,
        };

        // Cast to boolean
        this.print.useCoordinates = this.print.useCoordinates === true || this.print.useCoordinates !== 'false';
        this.print.showCityNames = this.print.showCityNames === 'true';

        window.bus.$on('syncUrl', () => {
            // console.log("BUS ON SYNCURL");
            this.syncUrl()
        });

        window.bus.$on('add-to-cart', () => {
            this.addToCart();
        })

        if (query) {
            this.search(query);
        }

        // console.log('beforeMount end');
    },

    methods: {
        rotate() {
            if (this.print.orientation === 'horizontal') {
                this.print.orientation = 'vertical';
                return
            }
            this.print.orientation = 'horizontal';
        },

        search(query) {
            const lang = 'nl'
            fetch('/api/geocode?language=' + lang + '&address=' + query)
                .then(x => x.json())
                .then(data => {

                    console.log(data);

                    if('features' in data && data.features.length > 0){
                        const lat = data.features[0].center[1];
                        const lng = data.features[0].center[0];
                        // const lat = data.features[0].geometry.coordinates[1];
                        // const lng = data.features[0].geometry.coordinates[0];
                        const city = data.features[0].text;

                        const location = {
                            'dms': ddToDms(lat, lng),
                            lat,
                            lng,
                            city,
                            country,
                            bounds
                        };

                        this.updateLocation(location);
                        this.trackSearch(query);

                        return;
                    }

                    if ('results' in data && data.results.length === 0) {
                        // todo mooier maken
                        alert('Locatie "' + query + '" niet gevonden');
                        return
                    }

                    let lat = (data.results[0].geometry.location.lat);
                    let lng = (data.results[0].geometry.location.lng);
                    let place = data.results[0];
                    let address_components = place.address_components;

                    // console.log(place);

                    // TODO what if not exists
                    let city_component = address_components.filter(component =>
                        component.types.includes('locality'),
                    );
                    if (city_component.length === 0) {
                        city_component = address_components.filter(component =>
                            component.types.includes('administrative_area_level_1'),
                        );
                    }
                    if (city_component.length === 0) {
                        city_component = address_components;
                    }

                    let country_component = address_components.filter(component =>
                        component.types.includes('country'),
                    );
                    if (country_component.length === 0) {
                        country_component = address_components;
                    }

                    const city = city_component[0].long_name;
                    const country = country_component[0].long_name;

                    const bounds = [
                        [
                            place.geometry.viewport.southwest.lat,
                            place.geometry.viewport.southwest.lng
                        ], [
                            place.geometry.viewport.northeast.lat,
                            place.geometry.viewport.northeast.lng,
                        ]
                    ];

                    const location = {
                        'dms': ddToDms(lat, lng),
                        lat,
                        lng,
                        city,
                        country,
                        bounds
                    };

                    this.updateLocation(location);
                    this.trackSearch(query);
                });

        },
        trackSearch(query) {
            try {
                if (typeof window.fbq !== 'undefined') {
                    window.fbq('track', 'Search',
                        {
                            search_string: query,
                        }
                    );
                }
            } catch (ignored) {
            }
        },
        setCoordinates() {
            // console.log('setCoordinates', 'this.print.useCoordinates', this.print.useCoordinates)
            const {lng, lat} = ddToDms(this.print.lat, this.print.lng, false, true, false)
            this.print.subtitle = `${lat} ${lng}`

            this.print.useCoordinates = true
        },
        addToCart() {
            const params = new URLSearchParams(this.print);
            params.append('type', type);

            window.open(`/shoppingcart/add/?${params}`);
        },

        updateLocation($event) {
            this.print.lat = $event.lat;
            this.print.lng = $event.lng;
            this.print.title = $event.city;
            this.print.city = $event.city;
        },

        // const base64 = JSON.stringify(window.print);
        // console.log('base64', base64)
        // location.hash = base64;
        syncUrl() {
            const params = new URLSearchParams(this.print);
            window.history.replaceState({}, '', `${location.pathname}?${params}`);
        },

        paramsToObject: (entries) => {
            let result = {};
            for (let entry of entries) { // each 'entry' is a [key, value] tupple
                const [key, value] = entry;
                result[key] = value;
            }
            return result;
        }
    },
};